import { render, staticRenderFns } from "./dishModelManagement.vue?vue&type=template&id=0d013a29&scoped=true&"
import script from "./dishModelManagement.vue?vue&type=script&lang=js&"
export * from "./dishModelManagement.vue?vue&type=script&lang=js&"
import style0 from "./dishModelManagement.vue?vue&type=style&index=0&id=0d013a29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d013a29",
  null
  
)

export default component.exports